<template>
  <div v-if="lists.meta">
    <a-table
      :columns="columns"
      :loading="!lists.data.length"
      :pagination="false"
      :style="{margin:'auto',background:'#fff',marginBottom:'20px'}"
      :dataSource="lists.data"
      :bordered="false"
      :rowKey="record => record.id"
    >
      <router-link
        :to="{name:'sites.lists.subscribers',params:{siteId:$route.params.siteId,listId:lists.id}}"
        slot="name"
        slot-scope="name,lists"
      >{{name}}</router-link>
    </a-table>
    <template v-if="lists.meta">
      <a-pagination
        @change="pagination"
        v-model="lists.meta.current_page"
        :pageSize="lists.meta.per_page"
        :defaultCurrent="1"
        :total="lists.meta.total"
        :style="{justifyContent:'flex-end',display:'flex'}"
      />
    </template>
  </div>
</template>
<script>
const columns = [
  {
    title: "List Name",
    dataIndex: "name",
    key: "2",
    width: "20%",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: "20%"
  },
  {
    title: "Subscribed",
    dataIndex: "subscribed",
    key: "subscribed",
    width: "10%"
  },
  {
    title: "Unsubscribed",
    dataIndex: "unsubscribed",
    key: "unsubscribed",
    width: "15%"
  },
  {
    title: "Unconfirmed",
    dataIndex: "unconfirmed",
    key: "unconfirmed",
    width: "15%"
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    width: "20%"
  }
];

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      columns,
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      lists: "sites/lists"
    })
  },
  methods: {
    pagination: function(a, b) {
      this.$store.commit("sites/PAGINATE_LISTS", {
        siteId: this.$route.params.siteId,
        page: a
      });
    }
  },
  beforeCreate() {
    this.$store.commit("sites/GET_LISTS", this.$route.params.siteId);
  }
};
</script>

